import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { createBibFieldSelector } from 'app/selectors/catalogBibs/CatalogBibSelector';
import Contains from './Contains';

const selectContainedWork = createBibFieldSelector('CONTAINS', 'CONTAINS_WORK');

export class ContainsContainer extends React.PureComponent {
  render() {
    return this.props.containedWork ? <Contains {...this.props} /> : null;
  }
}

ContainsContainer.propTypes = {
  containedWork: ImmutablePropTypes.listOf(ImmutablePropTypes.map)
};

const mapStateToProps = state => ({ containedWork: selectContainedWork(state)?.get('fieldValues') });

export default connect(mapStateToProps)(ContainsContainer);
